<template>
<div id="app">

    <v-card color="grey lighten-4" flat>
        <v-layout row wrap>
            <v-flex xs12 sm12 md12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title> Saç Ekim Formu</v-toolbar-title>
                </v-toolbar>
            </v-flex>
        </v-layout>

        <v-form ref="formsacekim" v-model="validform" lazy-validation>
            <v-flex xs12 sm12 md12 pa-2>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                        <v-card class="mx-auto">
                            <v-layout pl-4 row wrap>

                                <v-flex xs12 sm12 md12>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm6 md3>
                                            <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" :label="$t('Name_label')" v-model="RequestInput.Name" persistent-hint>
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 pl-2 sm6 md3>
                                            <v-text-field :label="$t('Surname_label')" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="RequestInput.LastName">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 pl-2 sm6 md3>
                                            <v-text-field :label="$t('Email_label')" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="RequestInput.Mail">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 md3>
                                            <tarihcomp :rules="[v => !!v || $t('Mandatory-Areas')]" :etiket="$t('Date-of-Birth')" v-model="RequestInput.BirthDate" v-bind:detaygizle="false" v-bind:defaultvalue="'yes'">
                                            </tarihcomp>
                                        </v-flex>
                                    </v-layout>

                                </v-flex>

                                <v-flex pt-2 xs12 sm12 md12>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="RequestInput.AlwaysMedicine" label="Sürekli Kullandığınız bir ilaç var mı?" hint="Varsa lütfen adını, günlük dozu ( 100mg - 2x1 vb.), kullandığınız süreyi yazınız. Eğer yoksa yok yazabilirsiniz." persistent-hint>
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 md6>
                                            <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="RequestInput.GetTherapy" label="Bu zamana kadar saç dökülmesi için tedavi aldınız mı?" hint="İlaç tedavisi ise ilaç adını ve dozunu, PRP-Mezoterapi gibi tedaviler ise seans sayısını yazınız." persistent-hint>
                                            </v-text-field>
                                        </v-flex>
                                        <v-radio-group :label="$t('Sex')" v-model="RequestInput.Gender" row>
                                            <v-radio :label="$t('Male')" value="Erkek"></v-radio>
                                            <v-radio :label="$t('Female')" value="Kadın"></v-radio>
                                        </v-radio-group>
                                        <v-flex xs12 sm6 md12>
                                            <v-text-field v-model="RequestInput.Menstrual" label="Menstrual döngünüzde bir sorun var mı? Son 6 ay içinde doğum yaptınız mı?" hint="Erkek hastalarımız işaretlemeden boş bırakabilir." persistent-hint>
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex pt-2 xs12 sm12 md6>
                                    <label class="bigText"> Saçınızın en çok döküldüğü bölümden 1 tutam saçı dibinden hafifçe tutarak yukarıya doğru çekin. Kaç adet saç teli geldi? </label>
                                    <v-radio-group :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="RequestInput.HairLossCount">
                                        <v-radio label="1-5" value="1 - 5"></v-radio>
                                        <v-radio label="5-10" value="5 - 10"></v-radio>
                                        <v-radio label="10 dan fazla" value="10 dan fazla"></v-radio>
                                    </v-radio-group>
                                    <v-radio-group :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="RequestInput.LoosFiveKg" label="Son 6 ay içinde 5 kilo veya daha fazlasını verdiniz mi?">
                                        <v-radio :label="$t('Yes')" value="Evet"></v-radio>
                                        <v-radio :label="$t('No-v2')" value="Hayır"></v-radio>
                                        <v-radio label="Bilmiyorum" value="Bilmiyorum"></v-radio>
                                    </v-radio-group>

                                    <v-radio-group :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="RequestInput.SurgicalOperation" label="Son 6 ay içinde büyük bir cerrahi operasyon geçirdiniz mi?">
                                        <v-radio :label="$t('Yes')" value="Evet"></v-radio>
                                        <v-radio :label="$t('No-v2')" value="Hayır"></v-radio>
                                        <v-radio label="Bilmiyorum" value="Bilmiyorum"></v-radio>
                                    </v-radio-group>

                                    <v-radio-group :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="RequestInput.ShowerHairLoss" label="Banyo veya duş sırasında saçlarınızın çok döküldüğüne şahit olur musunuz? ">
                                        <v-radio :label="$t('Yes')" value="Evet"></v-radio>
                                        <v-radio :label="$t('No-v2')" value="Hayır"></v-radio>
                                        <v-radio label="Bilmiyorum" value="Bilmiyorum"></v-radio>
                                    </v-radio-group>

                                    <v-radio-group :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="RequestInput.AlwaysHairLoss" label="Saçlarınızın sürekli döküldüğünü düşünüyor musunuz? ">
                                        <v-radio :label="$t('Yes')" value="Evet"></v-radio>
                                        <v-radio :label="$t('No-v2')" value="Hayır"></v-radio>
                                        <v-radio label="Zaman Zaman" value="Zaman Zaman"></v-radio>
                                    </v-radio-group>

                                    <v-radio-group v-model="RequestInput.Diet" label="Ketojenik diyet, dukan diyeti gibi sıkı diyetler yapıyor musunuz?">
                                        <v-radio :label="$t('Yes')" value="Evet"></v-radio>
                                        <v-radio :label="$t('No-v2')" value="Hayır"></v-radio>
                                        <v-radio label="Zaman Zaman" value="Zaman Zaman"></v-radio>
                                    </v-radio-group>

                                    <v-radio-group :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="RequestInput.LocalOrGeneral" label="Saç dökülmeniz lokal bir bölgede mi tüm kafa derisinde yaygın mı görülmektedir?">
                                        <v-radio label="Lokal" value="Lokal"></v-radio>
                                        <v-radio :label="$t('tab_general')" :value="$t('tab_general')"></v-radio>
                                        <v-radio label="Kararsızım" value="Kararsızım"></v-radio>
                                    </v-radio-group>

                                    <v-radio-group :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="RequestInput.HairBurning" label="Kafa derinizde yanma, kaşıntı, kızarıklık var mı?">
                                        <v-radio :label="$t('Yes')" value="Evet"></v-radio>
                                        <v-radio :label="$t('No-v2')" value="Hayır"></v-radio>
                                        <v-radio label="Zaman Zaman" value="Zaman Zaman"></v-radio>
                                    </v-radio-group>

                                    <v-radio-group v-model="RequestInput.CheckUp" label="Son 6 ay içinde tam kan sayımı veya check-up yaptırdınız mı?">
                                        <v-radio :label="$t('Yes')" value="Evet"></v-radio>
                                        <v-radio :label="$t('No-v2')" value="Hayır"></v-radio>
                                    </v-radio-group>
                                    <v-radio-group v-model="RequestInput.Tiroid" label="Tiroid rahatsızlığınız var mı?">
                                        <v-radio :label="$t('Yes')" value="Evet"></v-radio>
                                        <v-radio :label="$t('No-v2')" value="Hayır"></v-radio>
                                        <v-radio label="Bilmiyorum" value="Bilmiyorum"></v-radio>
                                    </v-radio-group>
                                </v-flex>

                                <v-flex pt-2 xs12 sm12 md6>
                                    <label class="bigText"> Saç dökülmeniz ne zamandır devam ediyor ?</label>
                                    <label class="bigText"><br /> </label>
                                    <br />
                                    <v-radio-group v-model="RequestInput.HairLossTime">
                                        <v-radio label="1-6 Ay" value="1-6 Ay"></v-radio>
                                        <v-radio label="6 ay - 1 yıl" value="6 ay - 1 yıl"></v-radio>
                                        <v-radio label="1 yıldan fazla" value="1 yıldan fazla"></v-radio>
                                    </v-radio-group>

                                    <v-radio-group v-model="RequestInput.VitaminLoss" label="B12 Eksikliği tanısı ile ilaç kullanıyor musunuz?">
                                        <v-radio :label="$t('Yes')" value="Evet"></v-radio>
                                        <v-radio :label="$t('No-v2')" value="Hayır"></v-radio>
                                        <v-radio label="Bilmiyorum" value="Bilmiyorum"></v-radio>
                                    </v-radio-group>

                                    <v-radio-group v-model="RequestInput.Chemotherapy" label="Kemoterapi gördünüz mü?">
                                        <v-radio :label="$t('Yes')" value="Evet"></v-radio>
                                        <v-radio :label="$t('No-v2')" value="Hayır"></v-radio>
                                        <v-radio label="10 yıldan fazla oldu" value="10 yıldan fazla oldu"></v-radio>
                                    </v-radio-group>

                                    <v-radio-group v-model="RequestInput.Diabetes" label="Diyabetiniz var mı?">
                                        <v-radio :label="$t('Yes')" value="Evet"></v-radio>
                                        <v-radio :label="$t('No-v2')" value="Hayır"></v-radio>
                                        <v-radio label="Bilmiyorum" value="Bilmiyorum"></v-radio>
                                    </v-radio-group>

                                    <v-radio-group v-model="RequestInput.IronLoss" label="Hiç demir eksikliği tanısı ile ilaç kullandınız mı?">
                                        <v-radio :label="$t('Yes')" value="Evet"></v-radio>
                                        <v-radio :label="$t('No-v2')" value="Hayır"></v-radio>
                                        <v-radio label="Bilmiyorum" value="Bilmiyorum"></v-radio>
                                    </v-radio-group>

                                    <v-radio-group v-model="RequestInput.FamilyHairLoss" label="Ailenizde saç dökülmesi sorunu var mı? ">
                                        <v-radio :label="$t('Yes')" value="Evet"></v-radio>
                                        <v-radio :label="$t('No-v2')" value="Hayır"></v-radio>
                                        <v-radio label="Bilmiyorum" value="Bilmiyorum"></v-radio>
                                    </v-radio-group>

                                    <v-radio-group :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="RequestInput.Vegetarian" label="Vejeteryan mısınız?">
                                        <v-radio :label="$t('Yes')" value="Evet"></v-radio>
                                        <v-radio :label="$t('No-v2')" value="Hayır"></v-radio>
                                        <v-radio label="Zaman Zaman" value="Zaman Zaman"></v-radio>
                                    </v-radio-group>

                                    <v-radio-group :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="RequestInput.HairColor" label="Doğal saç renginiz nedir?">
                                        <v-radio label="Sarışın" value="Sarışın"></v-radio>
                                        <v-radio label="Kumral" value="Kumral"></v-radio>
                                        <v-radio label="Esmer" value="Esmer"></v-radio>
                                    </v-radio-group>

                                    <v-radio-group :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="RequestInput.HairThickness" label="Saç tellerinizin kalınlığı nasıldır?">
                                        <v-radio label="İnce telli" value="İnce Telli"></v-radio>
                                        <v-radio label="Orta kalınlıkta" value="Orta Kalınlıkta"></v-radio>
                                        <v-radio label="Kalın telli" value="Kalın Telli"></v-radio>
                                    </v-radio-group>

                                    <v-flex xs12 sm12 md12>

                                        <v-item-group>
                                            <v-container>
                                                <v-layout wrap>
                                                    <v-flex xs4 md2>
                                                        <v-item>
                                                            <v-card slot-scope="{ active, toggle }" :color="active ? 'primary' : ''" class="d-flex align-center" dark height="75" width="75" @click="toggle">
                                                                <v-scroll-y-transition>
                                                                    <v-btn v-if="photoStatus" flat fab @click="addFiles()">
                                                                        <v-icon color="info">add_a_photo</v-icon>
                                                                    </v-btn>
                                                                    <v-btn v-else flat fab @click="addFiles()">
                                                                        <v-icon color="info">check</v-icon>
                                                                    </v-btn>
                                                                </v-scroll-y-transition>
                                                            </v-card>
                                                        </v-item>
                                                    </v-flex>
                                                    <v-flex pl-1 xs4 md2>
                                                        <v-item>
                                                            <v-card slot-scope="{ active, toggle }" :color="active ? 'primary' : ''" class="d-flex align-center" dark height="75" width="75" @click="toggle">
                                                                <v-scroll-y-transition>
                                                                    <v-btn v-if="photoStatustwo" flat fab @click="addFiles2()">
                                                                        <v-icon color="info">add_a_photo</v-icon>
                                                                    </v-btn>
                                                                    <v-btn v-else flat fab @click="addFiles2()">
                                                                        <v-icon color="info">check</v-icon>
                                                                    </v-btn>
                                                                </v-scroll-y-transition>
                                                            </v-card>
                                                        </v-item>
                                                    </v-flex>
                                                    <v-flex pl-1 xs4 md2>
                                                        <v-item>
                                                            <v-card slot-scope="{ active, toggle }" :color="active ? 'primary' : ''" class="d-flex align-center" dark height="75" width="75" @click="toggle">
                                                                <v-scroll-y-transition>
                                                                    <v-btn flat v-if="photoStatusthree" fab @click="addFiles3()">
                                                                        <v-icon color="info">add_a_photo</v-icon>
                                                                    </v-btn>
                                                                    <v-btn flat v-else fab @click="addFiles3()">
                                                                        <v-icon color="info">check</v-icon>
                                                                    </v-btn>
                                                                </v-scroll-y-transition>
                                                            </v-card>
                                                        </v-item>
                                                    </v-flex>
                                                    <v-flex pl-1 xs4 md2>
                                                        <v-item>
                                                            <v-card slot-scope="{ active, toggle }" :color="active ? 'primary' : ''" class="d-flex align-center" dark height="75" width="75" @click="toggle">
                                                                <v-scroll-y-transition>
                                                                    <v-btn flat v-if="photoStatusfour" fab @click="addFiles4()">
                                                                        <v-icon color="info">add_a_photo</v-icon>
                                                                    </v-btn>
                                                                    <v-btn flat v-else fab @click="addFiles4()">
                                                                        <v-icon color="info">check</v-icon>
                                                                    </v-btn>
                                                                </v-scroll-y-transition>
                                                            </v-card>
                                                        </v-item>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-item-group>

                                        <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data" v-model="valid" lazy-validation>
                                            <input hidden :rules="[v => !!v || $t('Mandatory-Areas')]" type="file" id="file" ref="file" multiple v-on:change="handleFileUpload()" />
                                        </v-form>

                                        <v-form ref="formaktarimtwo" id="formaktarimtwo" method="post" enctype="multipart/form-data" v-model="valid" lazy-validation>
                                            <input hidden :rules="[v => !!v || $t('Mandatory-Areas')]" type="file" id="filetwo" ref="filetwo" multiple v-on:change="handleFileUpload2()" />
                                        </v-form>

                                        <v-form ref="formaktarimthree" id="formaktarimthree" method="post" enctype="multipart/form-data" v-model="valid" lazy-validation>
                                            <input hidden :rules="[v => !!v || $t('Mandatory-Areas')]" type="file" id="filethree" ref="filethree" multiple v-on:change="handleFileUpload3()" />
                                        </v-form>

                                          <v-form ref="formaktarimfour" id="formaktarimfour" method="post" enctype="multipart/form-data" v-model="valid" lazy-validation>
                                            <input hidden :rules="[v => !!v || $t('Mandatory-Areas')]" type="file" id="filefour" ref="filefour" multiple v-on:change="handleFileUpload4()" />
                                        </v-form>
                                        <!--
                                        <v-btn flat :loading="false" :disabled="false" color="info" @click="addFiles()">
                                            <v-icon color="info" left>add_a_photo</v-icon>3 Adet Fotoğraf Seçiniz
                                        </v-btn>
                                         -->

                                    </v-flex>
                                    <!-- <v-flex>

                                        <ul id="ulList">
                                        </ul>

                                    </v-flex>
                                    <v-flex pt-2 pl-2 pb-2 v-if="file.length>0" xs12 sm12 md12>
                                        <span>{{secilenSayi}} adet dosya seçildi</span>
                                    </v-flex>  -->
                                    <v-flex xs12 sm12 md12>
                                        <v-btn color="blue darken-1" flat @click.native="cekimAci=true">
                                            Çekim Açılarına Bakın
                                        </v-btn>

                                    </v-flex>
                                    <v-flex>
                                        <v-btn v-show="cancelPhoto" @click="ClearPhoto()" flat color="red">
                                            <v-icon>cancel</v-icon> Fotoğrafları Temizle
                                        </v-btn>
                                    </v-flex>
                                </v-flex>

                                <v-flex xs12 sm6 md12>
                                    <v-text-field v-model="RequestInput.RequestNote" label="Eklemek istediğiniz notlar?" hint="Sizi şüphelendiren durumlar varsa kısaca anlatabilirsiniz." persistent-hint>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md10>
                                </v-flex>
                                <v-flex xs12 sm6 md2 pr-3>
                                    <v-btn @click="SaveRequest()" block color="info">
                                        <v-icon color="white" left>send
                                        </v-icon>{{ $t('Send') }}
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-form>

        <v-dialog v-model="cekimAci" v-if="cekimAci" scrollable="" persistent="" max-width="600px">
            <v-card>
                <v-card-title>Çekim Açıları</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-layout row wrap="">
                        <v-flex xs12 sm12 md12>
                            <v-img src="https://services.arkman.com.tr/Clinista/images/img/SamplePhoto.jpeg"></v-img>
                        </v-flex>
                    </v-layout>

                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="cekimAci=false">{{$t('Close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>
    </v-card>

</div>
</template>

<script>
import auth from "@/api/auth.js"
import helpers from "@/components/app/customcomp/helpers.js"
import tarihcomp from "@/components/app/customcomp/tarihim.vue"
import axios from 'axios'

export default {
    data() {
        return {
            rules: {
                required: (value) => !!value || this.$t('Mandatory-Areas'),
            },
            photoStatus: true,
            photoStatustwo: true,
            photoStatusthree: true,
            photoStatusfour:true,
            cancelPhoto: false,
            validform: true,
            cekimAci: false,
            selected: [],
            tooltip: false,
            dosya1mesaj: null,
            valid: true,
            dosyayolu1: null,
            file: [],
            secilendosya: null,
            el: null,
            RequestInput: {
                LogInput: {
                    UserID: null,
                    CustomerID: null,
                },
                Name: null,
                LastName: null,
                Mail: null,
                BirthDate: null,
                Gender: null,
                AlwaysMedicine: null,
                GetTherapy: null,
                Menstrual: null,
                HairLossCount: null,
                LoosFiveKg: null,
                SurgicalOperation: null,
                ShowerHairLoss: null,
                AlwaysHairLoss: null,
                Diet: null,
                HairThickness: null,
                LocalOrGeneral: null,
                HairBurning: null,
                CheckUp: null,
                HairLossTime: null,
                VitaminLoss: null,
                Chemotherapy: null,
                Diabetes: null,
                IronLoss: null,
                FamilyHairLoss: null,
                Vegetarian: null,
                HairColor: null,
                RequestNote: null,
                Tiroid: null,
                CompanyName: null,
                CompanyId: null
            },
            secilenSayi: 0,
            text1: '',
            snackbar: false,
            loading: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
        }
    },
    components: {
        tarihcomp
    },
    beforeMount: beforeMount,
    methods: {
        addFiles() {
            this.$refs.file.click();

        },
        addFiles2() {
            this.$refs.filetwo.click();

        },
        addFiles3() {
            this.$refs.filethree.click();

        },
           addFiles4() {
            this.$refs.filefour.click();

        },
        handleFileUpload() {
            //this.file = []
            if (this.secilenSayi >= 4) {
                this.text1 = "Maksimum 4 Adet fotoğraf yükleyebilirsiniz."
                this.snackbar = true
            } else {

                if (this.$refs.file.files.length > 1) {
                    this.text1 =this.$t('Please-Select-One-Photo-at-a-Time.')
                    this.snackbar = true
                } else {

                    if (this.$refs.file.files != [] && this.$refs.file.files != null) {
                        this.cancelPhoto = true

                        var uploadedFiles = this.$refs.file.files;

                        var fp = document.getElementById('file');

                        var lg = uploadedFiles.length; // get length

                        //document.getElementById('ulList').innerHTML = '';

                        var items = uploadedFiles
                        var fragment = "";

                        if (lg > 0) {
                            for (var i = 0; i < lg; i++) {
                                var fileName = escape(items[i].name); // get file name
                                var fileSize = items[i].size; // get file size
                                var fileType = items[i].type; // get file type

                                if (fileType === "image/png" || fileType === "image/jpeg") {
                                    fragment += "<li>" + fileName + " (<b>" + fileSize +
                                        "</b> bytes)"
                                    this.secilenSayi += 1
                                } else {
                                    this.text1 = "Dosya Uzantısını kontrol ediniz. Sadece png ve jpg eklenebilir."
                                    this.snackbar = true
                                    this.secilenSayi = this.secilenSayi - 1

                                }

                            }
                            // document.getElementById('ulList').innerHTML = fragment;

                        }

                        if (this.secilenSayi >= 1) {
                            this.dosya1mesaj = this.secilenSayi +  " " + this.$t('pcs-of-files-selected')
                            this.photoStatus = false

                        } else {
                            this.dosya1mesaj = this.$t('file-has-been-chosen')
                        }

                        if (uploadedFiles.length > 0) {

                            for (var i = 0; i < uploadedFiles.length; i++) {

                                this.file.push(uploadedFiles[i]);
                            }

                        } else {

                        }
                    }
                }
            }

        },
        handleFileUpload2() {
            //this.file = []

            if (this.secilenSayi >= 4) {
                this.text1 = "Maksimum 4 Adet fotoğraf yükleyebilirsiniz."
                this.snackbar = true
            } else {
                if (this.$refs.filetwo.files.length > 1) {
                    this.text1 =this.$t('Please-Select-One-Photo-at-a-Time.')
                    this.snackbar = true
                } else {

                    if (this.$refs.filetwo.files != [] && this.$refs.filetwo.files != null) {
                        this.cancelPhoto = true

                        var uploadedFiles = this.$refs.filetwo.files;

                        var fp = document.getElementById('filetwo');

                        var lg = uploadedFiles.length; // get length

                        // document.getElementById('ulList').innerHTML = '';

                        var items = uploadedFiles
                        //var fragment = document.getElementById('ulList').innerText
                        var fragment = "";
                        if (lg > 0) {
                            for (var i = 0; i < lg; i++) {
                                var fileName = escape(items[i].name); // get file name
                                var fileSize = items[i].size; // get file size
                                var fileType = items[i].type; // get file type

                                if (fileType === "image/png" || fileType === "image/jpeg") {
                                    fragment += "<li>" + fileName + " (<b>" + fileSize +
                                        "</b> bytes)"
                                    this.secilenSayi += 1

                                } else {
                                    this.text1 = "Dosya Uzantısını kontrol ediniz. Sadece png ve jpg eklenebilir."
                                    this.snackbar = true
                                    this.secilenSayi = this.secilenSayi - 1

                                }

                            }
                            // document.getElementById('ulList').innerHTML = fragment;

                        }

                        if (this.secilenSayi >= 1) {
                            this.dosya1mesaj = this.secilenSayi +  " " + this.$t('pcs-of-files-selected')
                            this.photoStatustwo = false

                        } else {
                            this.dosya1mesaj = this.$t('file-has-been-chosen')
                        }

                        if (uploadedFiles.length > 0) {

                            for (var i = 0; i < uploadedFiles.length; i++) {

                                this.file.push(uploadedFiles[i]);
                            }

                        } else {

                        }
                    }
                }
            }

        },
        handleFileUpload3() {
            //this.file = []

            if (this.secilenSayi >= 4) {
                this.text1 = "Maksimum 4 Adet fotoğraf yükleyebilirsiniz."
                this.snackbar = true
            } else {
                if (this.$refs.filetwo.files.length > 1) {
                    this.text1 =this.$t('Please-Select-One-Photo-at-a-Time.')
                    this.snackbar = true
                } else {

                    if (this.$refs.filethree.files != [] && this.$refs.filethree.files != null) {
                        this.cancelPhoto = true

                        var uploadedFiles = this.$refs.filethree.files;

                        var fp = document.getElementById('filethree');

                        var lg = uploadedFiles.length; // get length

                        //document.getElementById('ulList').innerHTML = '';

                        var items = uploadedFiles
                        var fragment = "";

                        if (lg > 0) {
                            for (var i = 0; i < lg; i++) {
                                var fileName = escape(items[i].name); // get file name
                                var fileSize = items[i].size; // get file size
                                var fileType = items[i].type; // get file type

                                if (fileType === "image/png" || fileType === "image/jpeg") {
                                    fragment += "<li>" + fileName + " (<b>" + fileSize +
                                        "</b> bytes)"
                                    this.secilenSayi += 1

                                } else {
                                    this.text1 = "Dosya Uzantısını kontrol ediniz. Sadece png ve jpg eklenebilir."
                                    this.snackbar = true
                                    this.secilenSayi = this.secilenSayi - 1

                                }

                            }
                            //document.getElementById('ulList').innerHTML = fragment;

                        }

                        if (this.secilenSayi >= 1) {
                            this.dosya1mesaj = this.secilenSayi +  " " + this.$t('pcs-of-files-selected')
                            this.photoStatusthree = false

                        } else {
                            this.dosya1mesaj = this.$t('file-has-been-chosen')
                        }

                        if (uploadedFiles.length > 0) {

                            for (var i = 0; i < uploadedFiles.length; i++) {

                                this.file.push(uploadedFiles[i]);
                            }

                        } else {

                        }
                    }
                }
            }
        },
         handleFileUpload4() {
            //this.file = []

            if (this.secilenSayi >= 4) {
                this.text1 = "Maksimum 4 Adet fotoğraf yükleyebilirsiniz."
                this.snackbar = true
            } else {
                if (this.$refs.filefour.files.length > 1) {
                    this.text1 =this.$t('Please-Select-One-Photo-at-a-Time.')
                    this.snackbar = true
                } else {

                    if (this.$refs.filefour.files != [] && this.$refs.filefour.files != null) {
                        this.cancelPhoto = true

                        var uploadedFiles = this.$refs.filefour.files;

                        var fp = document.getElementById('filefour');

                        var lg = uploadedFiles.length; // get length

                        //document.getElementById('ulList').innerHTML = '';

                        var items = uploadedFiles
                        var fragment = "";

                        if (lg > 0) {
                            for (var i = 0; i < lg; i++) {
                                var fileName = escape(items[i].name); // get file name
                                var fileSize = items[i].size; // get file size
                                var fileType = items[i].type; // get file type

                                if (fileType === "image/png" || fileType === "image/jpeg") {
                                    fragment += "<li>" + fileName + " (<b>" + fileSize +
                                        "</b> bytes)"
                                    this.secilenSayi += 1

                                } else {
                                    this.text1 = "Dosya Uzantısını kontrol ediniz. Sadece png ve jpg eklenebilir."
                                    this.snackbar = true
                                    this.secilenSayi = this.secilenSayi - 1

                                }

                            }
                            //document.getElementById('ulList').innerHTML = fragment;

                        }

                        if (this.secilenSayi >= 1) {
                            this.dosya1mesaj = this.secilenSayi +  " " + this.$t('pcs-of-files-selected')
                            this.photoStatusfour = false

                        } else {
                            this.dosya1mesaj = this.$t('file-has-been-chosen')
                        }

                        if (uploadedFiles.length > 0) {

                            for (var i = 0; i < uploadedFiles.length; i++) {

                                this.file.push(uploadedFiles[i]);
                            }

                        } else {

                        }
                    }
                }
            }
        },
        DosyalariYukle(ReqID) {
            var cred = JSON.parse(window.localStorage.getItem('credentials'));
            if (this.file.length > 0) {
                this.loadingvmodel = true
                let formData = new FormData();
                for (var i = 0; i < this.file.length; i++) {
                    let file = this.file[i];
                    formData.append('file[' + i + ']', file);
                    formData.append('RequestCode', ReqID)
                    axios.defaults.baseURL = auth.CLINISTA_API_URL;
                    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
                    axios.post(auth.CLINISTA_API_URL + 'api/Clinista/FileUpload',
                            formData, {
                                headers: {
                                    'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' + auth
                                        .HOTELRUNNERUSERPASS)
                                }
                            }
                        ).then((response) => {

                        })
                        .catch(function () {
                            this.loadingvmodel = false
                            this.text1 = this.$t('Error-in-file-transfer-try-again') 
                            this.snackbar = true

                        });
                }
            }

        },
        ClearPhoto() {
            this.file = []
            this.$refs.file.files = null
            this.$refs.filetwo.files = null
            this.$refs.filethree.files = null
            this.photoStatus = true
            this.photoStatustwo = true
            this.photoStatusthree = true
            this.photoStatusfour =true
            this.secilenSayi = 0
        },
        SaveRequest: SaveRequest,
    }
}

function beforeMount() {

}

function SaveRequest() {
    if (this.file.length < 5) {

        if (this.$refs.formsacekim.validate()) {

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            this.RequestInput.LogInput.UserID = credentials.UserID
            this.RequestInput.LogInput.CustomerID = credentials.MusteriID
            this.RequestInput.CompanyName = credentials.SirketUnvani
            this.RequestInput.CompanyId = credentials.MusteriID
            var params = this.RequestInput

            this.$http.post(auth.CLINISTA_API_URL + 'api/Clinista/Save', params, {
                headers: {
                    'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' + auth
                        .HOTELRUNNERUSERPASS)
                }
            }).then((response) => {
                if (response.body.Status) {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                    this.DosyalariYukle(response.body.SaveID);
                } else {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                }
            }, (response) => {
                this.text1 = "Hatalı Kayıt."
                this.snackbar = true
            })
        }
    } else {
        this.text1 = "En Fazla 4 Adet Fotoğraf Ekleyebilirsiniz."
        this.snackbar = true
    }
}
</script>

<style scoped>
.bigText {
    font-weight: 550px;
    color: darkslategray !important;

}
</style>
